import {extendsAPIServices} from "./APIServices";
import getEnv from "../../helpers/common/getEnv";
import {DELETE, GET, POST, PUT} from "../../constants/HTTPConstants";

const baseAdminAPI = getEnv('baseFbResourceAPI');
const api = extendsAPIServices(baseAdminAPI);

export const _requestLoginAccount = (accountId, device = '') => {
    return api.makeAuthRequest({
        method: POST,
        url: `/google-accounts/${accountId}/login`,
        data: {
            device
        }
    })
}

export const _getListAccounts = (page = 1, limit) => {
    return api.makeAuthRequest({
        method: GET,
        url: '/google-accounts',
        params: {
            page,
            limit,
        },
    })
}

export const _getAccountStatistics = () => {
    return api.makeAuthRequest({
        method: GET,
        url: `/google-accounts/statistics`,
    })
}

export const _createNewAccount = ({email, password, recoverEmail, recoverPhone, note}) => {
    return api.makeAuthRequest({
        method: POST,
        url: '/google-accounts',
        data: {
            email, password, recoverEmail, recoverPhone, note
        },
    })
}

export const _updateAccountData = (accountId, updateData) => {
    return api.makeAuthRequest({
        method: PUT,
        url: `/google-accounts/${accountId}`,
        data: {
            ...updateData
        },
    })
}

export const _deleteAccount = (id) => {
    return api.makeAuthRequest({
        method: DELETE,
        url: `/google-accounts/${id}`,

    })
}


// WEBPACK FOOTER //
// ./src/services/apis/AccountServices.js